const commonEmailProviders = ["gmail", "yahoo", "hotmail", "outlook", "aol", "proton", "icloud"];

export const identifyReoUser = properties => {
    if (!properties || !properties.email || !window || !window.Reo || !window.Reo.identify) {
        return;
    }

    const domain = properties.email.split("@")[1];
    const domainName = domain.split(".")[0];

    const reoUser = {
        username: properties.email,
        type: "email"
    };

    if (properties.name) {
        reoUser.firstName = properties.name.split(" ")[0];
        reoUser.lastName = properties.name.split(" ")[1];
    }

    if (!commonEmailProviders.includes(domainName.toLowerCase())) {
        reoUser.company = domain;
    }

    window.Reo.identify(reoUser);
};
